export default __webpack_public_path__ + "static/planning-during-the-caretaker-period-4fa57232c5a54b7acdf603b177387305.jpg";